import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollContainer = 
      document.querySelector("main") || 
      document.querySelector(".app-shell__content") || 
      document.querySelector(".custom-table__scroll");

    if (scrollContainer) {
      scrollContainer.scrollTo({
        top: 0,
        behavior: "instant", 
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
}